import React, { useEffect, useState } from 'react';
import { getMascotByXP, MASCOT_LEVELS } from '../../../data/nurseAppModels';

const LevelUpModal = ({ isOpen, onClose, oldLevel, newLevel, rewards }) => {
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShowAnimation(true);
      // Auto close after 5 seconds
      const timer = setTimeout(() => {
        setShowAnimation(false);
        setTimeout(() => {
          onClose();
        }, 500);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const levelInfo = MASCOT_LEVELS[newLevel];
  const oldLevelInfo = MASCOT_LEVELS[oldLevel];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[10000] p-4">
      <div
        className={`bg-gradient-to-br from-purple-600 via-pink-600 to-yellow-500 rounded-lg shadow-2xl max-w-md w-full p-8 transform transition-all duration-500 ${
          showAnimation ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        }`}
      >
        {/* Confetti Animation */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute animate-bounce"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${2 + Math.random() * 2}s`
              }}
            >
              <span className="text-2xl">
                {['🎉', '🎊', '⭐', '✨', '💫'][Math.floor(Math.random() * 5)]}
              </span>
            </div>
          ))}
        </div>

        {/* Content */}
        <div className="relative z-10 text-center text-white">
          {/* Level Up Text */}
          <div className="mb-6">
            <h2 className="text-5xl font-bold mb-2 animate-pulse">LEVEL UP!</h2>
            <div className="text-3xl font-semibold">
              Level {oldLevel} → Level {newLevel}
            </div>
          </div>

          {/* Mascot Display */}
          <div className="mb-6">
            <div className="text-8xl mb-2 animate-bounce">👼</div>
            <div className="text-xl font-semibold">{levelInfo?.nameThai || 'Level Up!'}</div>
            <div className="text-sm opacity-90">{levelInfo?.description || ''}</div>
          </div>

          {/* Rewards */}
          {rewards && (
            <div className="bg-white bg-opacity-20 rounded-lg p-4 mb-6">
              <div className="text-lg font-semibold mb-3">รางวัลที่ได้รับ</div>
              <div className="space-y-2">
                {rewards.coins > 0 && (
                  <div className="flex items-center justify-center space-x-2">
                    <span className="text-2xl">🪙</span>
                    <span className="text-xl font-bold">{rewards.coins} T Coins</span>
                  </div>
                )}
                {rewards.points > 0 && (
                  <div className="flex items-center justify-center space-x-2">
                    <span className="text-2xl">⭐</span>
                    <span className="text-xl font-bold">{rewards.points} Points</span>
                  </div>
                )}
                {rewards.badge && (
                  <div className="flex items-center justify-center space-x-2">
                    <span className="text-2xl">🏅</span>
                    <span className="text-xl font-bold">Badge: {rewards.badge}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Close Button */}
          <button
            onClick={() => {
              setShowAnimation(false);
              setTimeout(() => {
                onClose();
              }, 500);
            }}
            className="bg-white text-purple-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </div>
  );
};

export default LevelUpModal;

